module.exports = __webpack_public_path__ + "static/media/Notifications.acc05ec2.svg";